import { PersistentStore } from "bi-lib";

const isDarkSchemePreferred = () => window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches ?? false;

export const themeModeStore = new PersistentStore<"light" | "dark">(
    "themeMode",
    isDarkSchemePreferred() ? "dark" : "light",
);
